import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import Question from 'on_web/components/shared/Question/Question';
import UserProfileContext from 'on_web/context/userProfileContext';

import { useTranslation } from 'react-i18next';

export default function DnaStep1ForPce(props) {
  const context = React.useContext(UserProfileContext);
  const [selectedUseDna, setSelectedUseDna] = useState(
    context ? context.user_metadata.dnaUsageOption : undefined
  );

  const onClickNext = () => {
    const userMetadata = context ? context.user_metadata : null;
    if (props.onClickNext && userMetadata) {
      userMetadata.dnaUsageOption = selectedUseDna;
      props.onClickNext(userMetadata);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const { t } = useTranslation();

  const questionsForYes = [
    {
      checked: selectedUseDna === '1',
      value: '1',
      label: t('onboarding.dnaSection.dnaStep1.question1ForYes'),
    },
    {
      checked: selectedUseDna === '2',
      value: '2',
      label: t('onboarding.dnaSection.dnaStep1.question2ForYes'),
    },
    {
      checked: selectedUseDna === '3',
      value: '3',
      label: t('onboarding.dnaSection.dnaStep1.question3ForYes'),
    },
  ];

  return (
    <div>
      <Header />
      <PceStepProgressIndicator selectedSlideIx={0} firstStep />

      <Question
        sectionTitle={t('pceOnboarding.dnaSection.dnaStep1.sectionTitle')}
        radioSelection={{ items: questionsForYes }}
        onAnswer={val => setSelectedUseDna(val)}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={selectedUseDna === undefined}
      />
    </div>
  );
}
